import type { HeaderLogoVariant, HeaderProps } from '../types';
import { useTranslation } from 'next-i18next';
import cx from 'classnames';
import { Link } from '@dx-ui/global-ui-prism';

type HeaderLogoProps = {
  variant?: HeaderLogoVariant;
  brand: HeaderProps['brand'];
};
export const HeaderLogo = ({ variant = 'default', brand }: HeaderLogoProps) => {
  const { t } = useTranslation('osc-header');
  const hiltonForTheStay = t('hiltonForTheStay');
  const altTextByCode: Record<string, string> = {
    WW: hiltonForTheStay,
    OU: `${hiltonForTheStay}, ${brand.name}`,
    LX: `${hiltonForTheStay}, SLH`,
  };
  const altText = altTextByCode[brand.code] ?? brand.name;

  return (
    <img
      src={
        variant === 'default'
          ? `/modules/assets/svgs/logos/${brand.code}.svg`
          : `/modules/assets/svgs/logos/${brand.code}_${variant}.svg`
      }
      alt={altText}
      className="header-logo"
    />
  );
};

type HeaderLogoLinkProps = {
  className?: string;
  anchorClassName?: string;
  variant?: HeaderLogoVariant;
  brand: HeaderProps['brand'];
  heading?: string;
};
export const HeaderLogoLink = ({
  className,
  variant,
  heading,
  anchorClassName,
  brand,
}: HeaderLogoLinkProps) => {
  const Wrapper = heading ? 'h1' : 'span';

  return (
    <Wrapper aria-label={heading ? heading : undefined} className={className}>
      <Link
        colorTheme="inherit"
        url={brand.url}
        underline={false}
        showNewWindowIcon={false}
        isNewWindow={brand?.target === '_blank'}
        {...(!!brand.onClick && { onClick: brand.onClick })}
        {...(!!brand.target && brand.target !== '_blank' && { target: brand.target })}
        anchorClassName={cx(
          'relative block h-14 w-28 overflow-hidden brand-lx:lg:w-44 brand-ou:lg:w-72',
          anchorClassName
        )}
        data-testid="brand-logo-link"
      >
        <HeaderLogo variant={variant} brand={brand} />
      </Link>
    </Wrapper>
  );
};
